import { inject, Pipe, PipeTransform } from '@angular/core';
import { NewsCategory } from './models/news-category';
import { NewsCategoryService } from './news-category.service';

/** The category name in the active language. */
@Pipe({
  name: 'newsCategory',
  pure: false
})
export class NewsCategoryPipe implements PipeTransform {
  private newsCategoryService = inject(NewsCategoryService);

  transform(category: NewsCategory | null | undefined): string {
    return this.newsCategoryService.categoryName(category);
  }

}
